class FindPatientDuplicateRequest {
    public number: string;
    public regionLookupId: string;

    constructor(init?: Partial<FindPatientDuplicateRequest>) {
        Object.assign(this, init);
    }

    public equals(obj: object): boolean {
        if (!obj || !(obj instanceof FindPatientDuplicateRequest))
            return false;

        return this.number === obj.number
            && this.regionLookupId === obj.regionLookupId;
    }
}

export { FindPatientDuplicateRequest };
